const CONFIG_NAMES = ['storeStart', 'storeStop', 'alwaysFill', 'doNotFill'];

export function buildConfigOverlay(data) {
    const flagsByStore = new Map();
    CONFIG_NAMES.forEach(configName => {
        data[configName].dates.forEach(({storeId, salesEndDate}) => {
            if (!flagsByStore.has(storeId)) {
                flagsByStore.set(storeId, new Map());
            }
            const flagsByDate = flagsByStore.get(storeId);
            flagsByDate.set(salesEndDate, {...flagsByDate.get(salesEndDate), [configName]: true});
        });
    });

    const closuresByStore = new Map();
    data.storeClosures.forEach(storeClosure => {
        closuresByStore.set(storeClosure.storeId, [...(closuresByStore.get(storeClosure.storeId) || []), storeClosure]);
    });

    return {flagsByStore, closuresByStore};
}
